import { SidebarItemsType } from "../../types/sidebar";

import { Bell, List, Settings, Filter, Mail, Home } from "react-feather";

const pagesSection = [
  {
    href: "/dash",
    icon: Home,
    title: "Domov",
  },
  {
    href: "/ads",
    icon: List,
    title: "Oglasi",
    children: [
      {
        href: "/ads/list/1",
        title: "Osebna vozila",
      },
      {
        href: "/ads/list/2",
        title: "Tovorna vozila",
      },
      {
        href: "/ads/list/3",
        title: "Delovni stroji",
      },
      // {
      //   href: "/ads/list/4",
      //   title: "Osebna vozila - Mobile",
      // },
    ],
  },
  {
    href: "/alerts",
    icon: Bell,
    title: "Obveščanje",
    children: [
      {
        icon: Mail,
        href: "/alerts/messages",
        title: "Poslana obvestila",
      },
      {
        icon: Filter,
        href: "/alerts/list",
        title: "Filtri",
        children: [
          {
            href: "/alerts/list/1",
            title: "Osebna vozila",
          },
          {
            href: "/alerts/list/2",
            title: "Tovorna vozila",
          },
          {
            href: "/alerts/list/3",
            title: "Delovni stroji",
          },
        ],
      },
    ],
  },
  // {
  //   href: "/analytics",
  //   icon: BarChart2,
  //   title: "Poročila",
  // },
  {
    href: "/settings",
    icon: Settings,
    title: "Nastavitve",
    children: [
      {
        href: "/settings/profile",
        title: "Račun",
      },
      {
        href: "/settings/alerts",
        title: "Obveščanje",
      },
      {
        href: "/settings/subscription",
        title: "Naročnina",
      },
    ],
  },
] as SidebarItemsType[];

const navItems = [
  {
    title: "",
    pages: pagesSection,
  },
];

export default navItems;
